module.exports = "https://trybtryb-legacy.web.app/img/cosmic.80de85ba.webp";